<template>
  <svg
    v-if="name === 'apple'"
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
  >
    <g fill-rule="nonzero">
      <path
        d="M46.173 19.967C49.927-1.838 19.797-.233 14.538.21c-.429.035-.648.4-.483.8 2.004 4.825 14.168 31.66 32.118 18.957zm13.18 1.636c1.269-.891 1.35-1.614.047-2.453l-2.657-1.71c-.94-.607-1.685-.606-2.532.129-5.094 4.42-7.336 9.18-8.211 15.24 1.597.682 3.55.79 5.265.328 1.298-4.283 3.64-8.412 8.088-11.534z"
      />
      <path
        d="M88.588 67.75c9.65-27.532-13.697-45.537-35.453-32.322-1.84 1.118-4.601 1.118-6.441 0-21.757-13.215-45.105 4.79-35.454 32.321 5.302 15.123 17.06 39.95 37.295 29.995.772-.38 1.986-.38 2.758 0 20.235 9.955 31.991-14.872 37.295-29.995z"
      />
    </g>
  </svg>
  <svg
    v-else-if="name === 'book'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M6 4H5a1 1 0 1 1 0-2h11V1a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V5a1 1 0 0 0-1-1h-7v8l-2-2-2 2V4z"
    />
  </svg>
  <svg
    v-else-if="name === 'briefcase'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16.5 16.5"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M15.125 10.0416V13.5833C15.125 14.4954 14.4693 15.2799 13.5651 15.4C11.8262 15.6308 10.052 15.75 8.25 15.75C6.44798 15.75 4.67378 15.6308 2.93487 15.4C2.03075 15.2799 1.375 14.4954 1.375 13.5833V10.0416M1.375 10.0416C1.53634 10.1791 1.72487 10.2877 1.93574 10.3578C3.92058 11.0177 6.04357 11.375 8.25002 11.375C10.4564 11.375 12.5794 11.0177 14.5643 10.3578C14.7751 10.2877 14.9637 10.1791 15.125 10.0416C15.5183 9.70636 15.75 9.19906 15.75 8.6574V5.50474C15.75 4.60396 15.1101 3.82568 14.2192 3.69238C13.2814 3.55206 12.3329 3.44429 11.375 3.37027C10.3438 3.29058 9.30164 3.25 8.25 3.25C7.19836 3.25 6.1562 3.29058 5.125 3.37027M1.375 10.0416C0.981732 9.70635 0.75 9.19905 0.75 8.65739V5.50474C0.75 4.60396 1.38992 3.82568 2.28078 3.69238C3.21861 3.55206 4.16708 3.44429 5.125 3.37027M11.375 3.37027V2.625C11.375 1.58947 10.5355 0.75 9.5 0.75H7C5.96447 0.75 5.125 1.58947 5.125 2.625V3.37027M8.25 8.875H8.25625V8.88125H8.25V8.875Z"
    />
  </svg>
  <svg
    v-else-if="name === 'calendar-days'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16.5 16.5"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M3.875 0.75V2.625M12.625 0.75V2.625M0.75 13.875V4.5C0.75 3.46447 1.58947 2.625 2.625 2.625H13.875C14.9105 2.625 15.75 3.46447 15.75 4.5V13.875M0.75 13.875C0.75 14.9105 1.58947 15.75 2.625 15.75H13.875C14.9105 15.75 15.75 14.9105 15.75 13.875M0.75 13.875V7.625C0.75 6.58947 1.58947 5.75 2.625 5.75H13.875C14.9105 5.75 15.75 6.58947 15.75 7.625V13.875M8.25 8.875H8.25625V8.88125H8.25V8.875ZM8.25 10.75H8.25625V10.7563H8.25V10.75ZM8.25 12.625H8.25625V12.6313H8.25V12.625ZM6.375 10.75H6.38125V10.7563H6.375V10.75ZM6.375 12.625H6.38125V12.6313H6.375V12.625ZM4.5 10.75H4.50625V10.7563H4.5V10.75ZM4.5 12.625H4.50625V12.6313H4.5V12.625ZM10.125 8.875H10.1313V8.88125H10.125V8.875ZM10.125 10.75H10.1313V10.7563H10.125V10.75ZM10.125 12.625H10.1313V12.6313H10.125V12.625ZM12 8.875H12.0063V8.88125H12V8.875ZM12 10.75H12.0063V10.7563H12V10.75Z"
    />
  </svg>
  <svg
    v-else-if="name === 'cheveron-down'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
    />
  </svg>
  <svg
    v-else-if="name === 'cheveron-right'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <polygon
      points="12.95 10.707 13.657 10 8 4.343 6.586 5.757 10.828 10 6.586 14.243 8 15.657 12.95 10.707"
    />
  </svg>
  <svg
    v-else-if="name === 'cheveron-left'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <polygon
      points="7.05 10.707 6.343 10 12 4.343 13.414 5.757 9.172 10 13.414 14.243 12 15.657 7.05 10.707"
    />
  </svg>
  <svg
    v-else-if="name === 'cursor-click'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 12.5 14.4481"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M8.27821 13.6979L7.37234 10.3171M7.37234 10.3171L5.6994 11.8007L6.07834 5.48749L9.5631 10.7654L7.37234 10.3171ZM6.25 0.75V2.25M10.1391 2.36091L9.07843 3.42157M11.75 6.25H10.25M3.42157 9.07843L2.36091 10.1391M2.25 6.25H0.75M3.42157 3.42157L2.36091 2.36091"
    />
  </svg>
  <svg
    v-else-if="name === 'dashboard'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm-5.6-4.29a9.95 9.95 0 0 1 11.2 0 8 8 0 1 0-11.2 0zm6.12-7.64l3.02-3.02 1.41 1.41-3.02 3.02a2 2 0 1 1-1.41-1.41z"
    />
  </svg>
  <svg
    v-else-if="name === 'location'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M10 20S3 10.87 3 7a7 7 0 1 1 14 0c0 3.87-7 13-7 13zm0-11a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
    />
  </svg>
  <svg
    v-else-if="name === 'office'"
    xmlns="http://www.w3.org/2000/svg"
    width="100"
    height="100"
    viewBox="0 0 100 100"
  >
    <path
      fill-rule="evenodd"
      d="M7 0h86v100H57.108V88.418H42.892V100H7V0zm9 64h11v15H16V64zm57 0h11v15H73V64zm-19 0h11v15H54V64zm-19 0h11v15H35V64zM16 37h11v15H16V37zm57 0h11v15H73V37zm-19 0h11v15H54V37zm-19 0h11v15H35V37zM16 11h11v15H16V11zm57 0h11v15H73V11zm-19 0h11v15H54V11zm-19 0h11v15H35V11z"
    />
  </svg>
  <svg
    v-else-if="name === 'printer'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M4 16H0V6h20v10h-4v4H4v-4zm2-4v6h8v-6H6zM4 0h12v5H4V0zM2 8v2h2V8H2zm4 0v2h2V8H6z"
    />
  </svg>
  <svg
    v-else-if="name === 'shopping-cart'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M4 2h16l-3 9H4a1 1 0 1 0 0 2h13v2H4a3 3 0 0 1 0-6h.33L3 5 2 2H0V0h3a1 1 0 0 1 1 1v1zm1 18a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm10 0a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
    />
  </svg>
  <svg
    v-else-if="name === 'store-front'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M18 9.87V20H2V9.87a4.25 4.25 0 0 0 3-.38V14h10V9.5a4.26 4.26 0 0 0 3 .37zM3 0h4l-.67 6.03A3.43 3.43 0 0 1 3 9C1.34 9 .42 7.73.95 6.15L3 0zm5 0h4l.7 6.3c.17 1.5-.91 2.7-2.42 2.7h-.56A2.38 2.38 0 0 1 7.3 6.3L8 0zm5 0h4l2.05 6.15C19.58 7.73 18.65 9 17 9a3.42 3.42 0 0 1-3.33-2.97L13 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'trash'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
    />
  </svg>
  <svg
    v-else-if="name === 'users'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M7 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm0 1c2.15 0 4.2.4 6.1 1.09L12 16h-1.25L10 20H4l-.75-4H2L.9 10.09A17.93 17.93 0 0 1 7 9zm8.31.17c1.32.18 2.59.48 3.8.92L18 16h-1.25L16 20h-3.96l.37-2h1.25l1.65-8.83zM13 0a4 4 0 1 1-1.33 7.76 5.96 5.96 0 0 0 0-7.52C12.1.1 12.53 0 13 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'grip'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <circle cx="5" cy="5" r="1.5" />
    <circle cx="10" cy="5" r="1.5" />
    <circle cx="15" cy="5" r="1.5" />
    <circle cx="5" cy="10" r="1.5" />
    <circle cx="10" cy="10" r="1.5" />
    <circle cx="15" cy="10" r="1.5" />
    <circle cx="5" cy="15" r="1.5" />
    <circle cx="10" cy="15" r="1.5" />
    <circle cx="15" cy="15" r="1.5" />
  </svg>
  <svg
    v-else-if="name === 'cog'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'edit'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
    />
  </svg>
  <svg
    v-else-if="name === 'eye'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
    />
  </svg>
  <svg
    v-else-if="name === 'warning'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M12 9v2m0 4h.01M10.29 3.86 1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'check'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M5 13l4 4L19 7"
    />
  </svg>
  <svg
    v-else-if="name === 'question-mark'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'user'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"
    />
    <circle cx="12" cy="7" r="4" stroke-width="2" />
  </svg>
  <svg
    v-else-if="name === 'stethoscope'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6 6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3"
    />
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M8 15v1a6 6 0 0 0 6 6 6 6 0 0 0 6-6v-4"
    />
    <circle cx="20" cy="10" r="2" stroke-width="2" />
  </svg>
  <svg
    v-else-if="name === 'information-circle'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
      d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
  <svg
    v-else-if="name === 'credit-card'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14.5 11.5"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M0.75 3.25H13.75M0.75 3.75H13.75M2.75 7.25H6.75M2.75 8.75H4.75M2.25 10.75H12.25C13.0784 10.75 13.75 10.0784 13.75 9.25V2.25C13.75 1.42157 13.0784 0.75 12.25 0.75H2.25C1.42157 0.75 0.75 1.42157 0.75 2.25V9.25C0.75 10.0784 1.42157 10.75 2.25 10.75Z"
    />
  </svg>
  <svg
    v-else-if="name === 'banknotes'"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17.75 15.1603"
    stroke="currentColor"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M0.75 12.625C5.306 12.625 9.71967 13.2344 13.914 14.376C14.5198 14.5409 15.125 14.0905 15.125 13.4626V12.625M2 0.75V1.375C2 1.72018 1.72018 2 1.375 2H0.75M0.75 2V1.6875C0.75 1.16973 1.16973 0.75 1.6875 0.75H15.75M0.75 2V9.5M15.75 0.75V1.375C15.75 1.72018 16.0298 2 16.375 2H17M15.75 0.75H16.0625C16.5803 0.75 17 1.16973 17 1.6875V9.8125C17 10.3303 16.5803 10.75 16.0625 10.75H15.75M17 9.5H16.375C16.0298 9.5 15.75 9.77982 15.75 10.125V10.75M15.75 10.75H2M2 10.75H1.6875C1.16973 10.75 0.75 10.3303 0.75 9.8125V9.5M2 10.75V10.125C2 9.77982 1.72018 9.5 1.375 9.5H0.75M11.375 5.75C11.375 7.13071 10.2557 8.25 8.875 8.25C7.49429 8.25 6.375 7.13071 6.375 5.75C6.375 4.36929 7.49429 3.25 8.875 3.25C10.2557 3.25 11.375 4.36929 11.375 5.75ZM13.875 5.75H13.8812V5.75625H13.875V5.75ZM3.875 5.75H3.88125V5.75625H3.875V5.75Z"
    />
  </svg>
  <svg
    v-else-if="name === 'search'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      d="M15.5 14h-.79l-.28-.27A6.5 6.5 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    />
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
